/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * GeofenceType is the grouping of project `geofence` details.
 *
 */
export var GeofenceType;
(function (GeofenceType) {
    GeofenceType["PROJECT_AREA"] = "projectArea";
    GeofenceType["JOB_SITE"] = "jobSite";
    GeofenceType["CHARGE_STATION"] = "chargeStation";
})(GeofenceType || (GeofenceType = {}));
